import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FaCode } from 'react-icons/fa';
import './Header.css';
import Chatbot from './Chatbot'; // Re-import the Chatbot component

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showChat, setShowChat] = useState(false); // State for chat visibility
  const [expanded, setExpanded] = useState(false); // State for navbar collapse
  const location = useLocation();

  const toggleChat = () => {
    setShowChat(!showChat); // Toggle chat visibility
    setExpanded(false); // Close the mobile navbar when chat is opened
  };

  // Function to handle navigation clicks and close mobile menu
  const handleNavClick = (path) => {
    console.log('Navigation clicked:', path);
    setExpanded(false); // Close the mobile navbar when a link is clicked
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar
        expand="lg"
        fixed="top"
        expanded={expanded}
        onToggle={setExpanded}
        className={`modern-navbar ${scrolled ? 'scrolled' : ''}`}
      >
        <Container>
          <Navbar.Brand as={Link} to="/" className="brand">
            <FaCode className="brand-icon" />
            <span className="brand-name">Rahul Bhoyar</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <div className="navbar-nav ms-auto">
              <Link
                to="/"
                className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
                onClick={() => handleNavClick('/')}
              >
                Home
              </Link>
              <Link
                to="/education"
                className={`nav-link ${location.pathname === '/education' ? 'active' : ''}`}
                onClick={() => handleNavClick('/education')}
              >
                Education
              </Link>
              <Link
                to="/experience"
                className={`nav-link ${location.pathname === '/experience' ? 'active' : ''}`}
                onClick={() => handleNavClick('/experience')}
              >
                Experience
              </Link>
              <Link
                to="/projects"
                className={`nav-link ${location.pathname === '/projects' ? 'active' : ''}`}
                onClick={() => handleNavClick('/projects')}
              >
                Projects
              </Link>
              <Link
                to="/publications"
                className={`nav-link ${location.pathname === '/publications' ? 'active' : ''}`}
                onClick={() => handleNavClick('/publications')}
              >
                Publications
              </Link>
              <Link
                to="/certifications"
                className={`nav-link ${location.pathname === '/certifications' ? 'active' : ''}`}
                onClick={() => handleNavClick('/certifications')}
              >
                Certifications
              </Link>
              {/* <Link
                to="/blog"
                className={`nav-link ${location.pathname === '/blog' ? 'active' : ''}`}
                onClick={() => handleNavClick('/blog')}
              >
                Blog
              </Link> */}
              <Link
                to="/contact"
                className={`nav-link ${location.pathname === '/contact' ? 'active' : ''}`}
                onClick={() => handleNavClick('/contact')}
              >
                Contact
              </Link>
              <button
                onClick={toggleChat}
                className="nav-link" // Use nav-link class for styling
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: 'var(--text-primary)', // Ensure text color matches
                  padding: '0.5rem 0.75rem', // Match Nav.Link padding
                  fontFamily: 'inherit',
                  fontSize: 'inherit',
                  lineHeight: 'inherit',
                  textAlign: 'center',
                  display: 'inline-block' // Ensure it behaves like other nav items
                }}
              >
                Chat With Rahul
              </button> 
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {/* Render Chatbot outside and sibling to Navbar */}
      {showChat && <Chatbot onClose={toggleChat} />}
    </>
  );
};

export default Header;
